import { Chip } from "@mui/material";

import { useShiftCardContext } from "./useShiftCard";

export function ShiftBoardShiftStatusChip() {
  const { chips } = useShiftCardContext();

  if (!chips || chips.length === 0) {
    return null;
  }

  return (
    <>
      {chips.map(({ status, color }, index) => (
        <Chip
          // eslint-disable-next-line react/no-array-index-key
          key={status + index}
          sx={color}
          label={status}
          size="small"
          style={{ marginRight: 4 }}
        />
      ))}
    </>
  );
}
